import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/useAuth";
import { Button } from "../components/ui/Button";

/**
 * Shown to authenticated users whose `associations[]` is empty — typically
 * accounts that just self-signed-up and are waiting on an admin to assign
 * them to a customer/operation. No new route; rendered as a layout-level
 * gate by `DashboardLayout`.
 */
export default function AwaitingAssociationPage() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-6">
      <div className="w-full max-w-md rounded-2xl border border-orange-200 bg-gradient-to-br from-orange-50 to-orange-100 p-10 text-center shadow-sm">
        <div className="mb-4 text-5xl">⏳</div>
        <h1 className="mb-2 text-2xl font-extrabold text-orange-900">
          {t("auth:awaitingAssociation.title")}
        </h1>
        <p className="mb-6 text-orange-800">
          {t("auth:awaitingAssociation.body")}
        </p>
        {user && (
          <div className="mb-6 flex flex-col items-center gap-2 text-sm text-orange-800">
            <div>📧 {user.email}</div>
            <div>👤 {user.name}</div>
          </div>
        )}
        <Button variant="secondary" onClick={logout}>
          {t("common:actions.logout")}
        </Button>
      </div>
    </div>
  );
}
